import * as React from 'react'
import {Lang} from 'yougile-lang'
import {ArrUtil, Updater, Util} from 'yougile-util'
import {ReportSchedule, Schedule as ScheduleT} from 'yougile-model'
import {BooleanHookState} from '@containers/hooks'
import {Checkbox} from '../../common/base/checkbox'
import {Input} from '../../common/controls/input'
import {ScheduleChooser} from '../../common/controls/schedule-chooser/schedule-chooser'

interface Props {
  schedule: ReportSchedule
  update: Updater<ReportSchedule>
  valid?: BooleanHookState
  isEmailValid: (email: string) => boolean
}

const ScheduleBase = (props: Props) => {
  const {schedule, update} = props
  const bem = Util.bemFrom('stats-reports-schedule')
  const {msg} = Lang

  const toggle = update(s => ({...s, enabled: !s.enabled}))
  const emailChange = (ix: number) => (value: string) =>
    update(s => ({
      ...s,
      emails: ArrUtil.changedAtIndex(s.emails, value, ix)
    }))()
  const addEmail = update(s => ({...s, emails: [...s.emails, '']}))
  const removeEmail = (ix: number) =>
    update(s => ({...s, emails: ArrUtil.deletedAtIndex(s.emails, ix)}))
  const updateTime = (time: ScheduleT) => update(s => ({...s, time}))()

  return (
    <div className={bem()}>
      <div className={bem('switch')}>
        <Checkbox
          value={schedule.enabled}
          onChange={toggle}
          text={msg.report.sendTurnedOn}
        />
      </div>

      <div className={bem('cnt', {disabled: !schedule.enabled})}>
        <div className={bem('emails')}>
          {schedule.emails.map((email, ix) => (
            <React.Fragment key={ix}>
              <Input
                className={bem('email')}
                placeholder={msg.emailPlaceholder}
                value={email}
                onChange={emailChange(ix)}
                type="email"
                isValid={props.isEmailValid}
              />
              {schedule.emails.length > 1 && (
                <div className={bem('remove')} onClick={removeEmail(ix)} />
              )}
            </React.Fragment>
          ))}

          {schedule.emails.length <= 20 && (
            <div className={bem('add')} onClick={addEmail}>
              {msg.report.addEmail}
            </div>
          )}
        </div>

        <ScheduleChooser
          className={bem('interval')}
          schedule={schedule.time}
          update={updateTime}
          valid={props.valid}
        >
          <div className={bem('interval', 'type')}>{msg.report.send}:</div>
        </ScheduleChooser>
      </div>
    </div>
  )
}

export const Schedule = (props: Props) => {
  return <ScheduleBase {...props} />
}
